(function() {
  class $1dd1ec3bfffb4a84$var$CountDownTimer extends HTMLElement {
    constructor() {
      super();
      this.timerInterval = null;
    }
    connectedCallback() {
      this.deadline = parseInt(this.getAttribute("data-deadline"), 10);
      this.template = this.getAttribute("data-template") || "{hours}h {minutes}m {seconds}s";
      if (!this.deadline || isNaN(this.deadline)) return;
      this.startCountdown();
    }
    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    }
    startCountdown() {
      const updateTimer = () => {
        const now = Date.now();
        const diff = this.deadline - now;
        if (diff <= 0) {
          if (this.timerInterval) clearInterval(this.timerInterval);
          this.innerHTML = "";
          this.classList.add("hidden");
          return;
        }
        const totalSeconds = Math.floor(diff / 1e3);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor(totalSeconds % 3600 / 60);
        const seconds = totalSeconds % 60;
        const pad = n => String(n).padStart(2, "0");
        const hourElements = this.querySelectorAll("[data-hours]");
        const minuteElements = this.querySelectorAll("[data-minutes]");
        const secondElements = this.querySelectorAll("[data-seconds]");
        if (hourElements.length > 0 || minuteElements.length > 0 || secondElements.length > 0) {
          hourElements.forEach(el => el.textContent = pad(hours));
          minuteElements.forEach(el => el.textContent = pad(minutes));
          secondElements.forEach(el => el.textContent = pad(seconds));
        } else {
          const output = this.template.replace("{hours}", pad(hours)).replace("{minutes}", pad(minutes)).replace("{seconds}", pad(seconds));
          this.textContent = output;
          this.classList.remove("hidden");
        }
      };
      updateTimer();
      this.timerInterval = setInterval(updateTimer, 1e3);
    }
  }
  if (!customElements.get("count-down")) customElements.define("count-down", $1dd1ec3bfffb4a84$var$CountDownTimer);
})();